<mat-icon class="toast-icon" [svgIcon]="iconForToastType()" aria-hidden="true" />
<div class="toast-content">
    @if (title()) {
        <p [class]="options().titleClass" [attr.aria-label]="title()" class="mb-0 fw-bold">
            {{ title() }}
        </p>
    }
    @if (message()) {
        @if (options().enableHtml) {
            <div role="alert" [class]="options().messageClass" [innerHTML]="message()"></div>
        } @else {
            <p
                role="alert"
                [class]="options().messageClass"
                [attr.aria-label]="message()"
                class="mb-0"
            >
                {{ message() }}
            </p>
        }
    }
</div>
@if (options().closeButton) {
    <button type="button" class="btn-close" data-bs-dismiss="toastr" aria-label="Close"></button>
}
@if (options().progressBar) {
    <div class="toast-progress" [style.width]="width + '%'"></div>
}
